{
  "title": "Overview",
  "cards": {
    "users": "Number of users",
    "debtors": "Number of debtors",
    "revolvingBalances": "Carried balances",
    "purchases": "Purchases",
    "sales": "Sales",
    "debtSales": "Debt sales",
    "payments": "Payments",
    "receipts": "Receipts"
  },
  "products": {
    "DIESEL": "Diesel",
    "PETROL": "Petrol"
  },
  "branchFilter": "Branch",
  "empty": {
    "noProducts": "No product is available to this user"
  },
  "lock": {
    "label": "Password",
    "submit": "Show statistics",
    "hint": "Enter the overview password to see the statistics",
    "required": "Password is required",
    "notSetLink": "Prices and settings",
    "logoAlt": "Al-Musafer"
  }
}
